import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useInspectionCreationViewModel = ({
  homeId = "",
  selectedInspectionTemplate = {},
  onSubmit = () => null,
}) => {
  const stateManager = useComponentState();

  const create = async (data) =>
    stateManager.run(async () =>
      taskService.inspection.create({
        data,
        toastMessageConfig: {
          success: {
            text: "Inspection created successfully.",
          },
        },
      })
    );

  const createInspection = () => {
    stateManager.run(async () => {
      const { status } = await create({
        inspectionTemplateId: selectedInspectionTemplate.id,
        homeId,
      });

      if (status === HTTP_STATUSES.CREATED) {
        onSubmit();
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    createInspection,
  };
};
